import { render, staticRenderFns } from "./LgFinderPageTipoMedida.vue?vue&type=template&id=79c661ac"
import script from "./LgFinderPageTipoMedida.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoMedida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports